module.exports = __webpack_public_path__ + "static/media/ic_remove_primary300.f5f56ca8.svg";